import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Ingredient } from 'public-contracts';
import { ModernIngredientList } from './ModernIngredientList';
import { ModernIngredientForm } from './ModernIngredientForm';

export const ModernIngredientManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingIngredient, setEditingIngredient] = useState<Ingredient | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingIngredient(null);
    setFormOpen(true);
  };

  const handleEditClick = (ingredient: Ingredient) => {
    setEditingIngredient(ingredient);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingIngredient(null);
  };

  const handleFormSave = async (ingredient: Ingredient) => {
    console.log('✅ handleFormSave called, closing dialog first');
    setFormOpen(false);
    setEditingIngredient(null);
    
    // Trigger refresh of the ingredient list after a short delay to ensure API call completes
    setTimeout(() => {
      setRefreshKey((prev) => {
        console.log(`✅ refreshKey changed from ${prev} to ${prev + 1}`);
        return prev + 1;
      });
    }, 500);
  };

  return (
    <div className="container mx-auto p-6" data-testid="ingredient-management">
      <ModernIngredientList
        key={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernIngredientForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        ingredient={editingIngredient}
      />
    </div>
  );
};

